// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form_tlzKC {
  width: 400px;
  /* max-width: 100vw; */
  max-height: 60vh;
  /* padding: 16px; */
}
.fixed_bQlLC {
  width : 100%;
  position : relative;
  height : 100%;
}
.selector_mfG1b {
  flex-grow: 1;
}
.divider_QPTW2 {
  width: 100%;
  margin: 0;
}

.mapFields_OJK5W {
  width : 640px;
}

.mapFieldsBody_YBouA {
  max-height: 60vh;
}

.mapFieldsBodyHeader_R6InD {
  padding-bottom: var( --size-padMedium, 8px );
}

.warning_F8kJx, .success_v6a3x {
  width: 100%;
}

.warning_F8kJx > i {
  color: var( --color-danger700 );
  font-size: 15px;
}

.warningContainer__go6E {
  width: 100%;
  padding: var( --size-padMedium, 12 );
  border: 1px solid var( --color-danger700 );
  border-radius: var( --size-medium );
  background-color: var( --color-white, #FFFFFF );
}

.success_v6a3x > i {
  color: var( --color-success700 );
  font-size: 15px;
}

.successContainer_tq8qm {
  width: 100%;
  padding: var( --size-padMedium, 12 );
  border: 1px solid var( --color-success700 );
  border-radius: var( --size-medium );
  background-color: var( --color-white, #FFFFFF );
}

.csvField_fHAF4 {
  max-width: 240px;
  padding-top: var( --size-padMedium );
  min-height: 60px;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/molten/lib/imagine/forms/CreateEditForm.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,0CAA0C;EAC1C,mCAAmC;EACnC,+CAA+C;AACjD;;AAEA;EACE,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,2CAA2C;EAC3C,mCAAmC;EACnC,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":[".form {\n  width: 400px;\n  /* max-width: 100vw; */\n  max-height: 60vh;\n  /* padding: 16px; */\n}\n.fixed {\n  width : 100%;\n  position : relative;\n  height : 100%;\n}\n.selector {\n  flex-grow: 1;\n}\n.divider {\n  width: 100%;\n  margin: 0;\n}\n\n.mapFields {\n  width : 640px;\n}\n\n.mapFieldsBody {\n  max-height: 60vh;\n}\n\n.mapFieldsBodyHeader {\n  padding-bottom: var( --size-padMedium, 8px );\n}\n\n.warning, .success {\n  width: 100%;\n}\n\n.warning > i {\n  color: var( --color-danger700 );\n  font-size: 15px;\n}\n\n.warningContainer {\n  width: 100%;\n  padding: var( --size-padMedium, 12 );\n  border: 1px solid var( --color-danger700 );\n  border-radius: var( --size-medium );\n  background-color: var( --color-white, #FFFFFF );\n}\n\n.success > i {\n  color: var( --color-success700 );\n  font-size: 15px;\n}\n\n.successContainer {\n  width: 100%;\n  padding: var( --size-padMedium, 12 );\n  border: 1px solid var( --color-success700 );\n  border-radius: var( --size-medium );\n  background-color: var( --color-white, #FFFFFF );\n}\n\n.csvField {\n  max-width: 240px;\n  padding-top: var( --size-padMedium );\n  min-height: 60px;\n  align-items: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": `form_tlzKC`,
	"fixed": `fixed_bQlLC`,
	"selector": `selector_mfG1b`,
	"divider": `divider_QPTW2`,
	"mapFields": `mapFields_OJK5W`,
	"mapFieldsBody": `mapFieldsBody_YBouA`,
	"mapFieldsBodyHeader": `mapFieldsBodyHeader_R6InD`,
	"warning": `warning_F8kJx`,
	"success": `success_v6a3x`,
	"warningContainer": `warningContainer__go6E`,
	"successContainer": `successContainer_tq8qm`,
	"csvField": `csvField_fHAF4`
};
export default ___CSS_LOADER_EXPORT___;
